import { styled } from '@mui/system'
import { Box, type BoxProps } from '@mui/material'
interface StickyCompactHeaderOffsetProps extends BoxProps {
  stickyCompactHeaderHeight?: number
}

interface StickyCompactHeaderProps extends BoxProps {
  appBarHeight?: number
}

interface HeaderDetailsContainerProps extends BoxProps {
  hasControls?: boolean
}

export const FullSizedHeader = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    flexWrap: 'wrap'
  }
}))

export const HeaderDetailsContainer = styled(Box)<HeaderDetailsContainerProps>(({ theme, hasControls }) => ({
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    marginBottom: hasControls ? theme.spacing(4) : 0
  }
}))

export const StickyCompactHeaderOffset = styled(Box)<StickyCompactHeaderOffsetProps>(({ stickyCompactHeaderHeight = 72 }) => ({
  minHeight: `${stickyCompactHeaderHeight}px`
}))

export const StickyCompactHeader = styled(Box)<StickyCompactHeaderProps>(({ theme, appBarHeight = 0 }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100vw',
  position: 'fixed',
  marginTop: '0px !important',
  padding: `${theme.spacing(4)} ${theme.spacing(12)}`,
  // Pin below the real app bar height (see useAppBarHeight); theme spacing was a rough proxy
  top: `${appBarHeight}px !important`,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    padding: `0 ${theme.spacing(4)} ${theme.spacing(4)}`
  },
  left: 0,
  zIndex: 7,
  backgroundColor: 'white',
  boxShadow: '0px 4px 8px -2px rgba(32, 41, 57, 0.10), 0px 2px 4px -2px rgba(32, 41, 57, 0.06)'
}))
